import { Box, FormControlLabel, FormLabel, Paper, styled, Switch, Typography } from '@mui/material';

export const MainContainer = styled(Box)(({ theme }) => ({
    padding: theme.typography.generic.xxxxxLarge,
    background: theme.palette.background.none,
    height: '100%',
    width: '100%',

    [theme.breakpoints.down('sm')]: {
        padding: ` ${theme.typography.generic.xxxLarge} ${theme.typography.generic.xLarge}`,
    },

    '@media (min-width:1640px)': {
        maxWidth: '1640px',
    },
}));

export const PaperBox = styled(Paper)(({ theme }) => {
    return {
        padding: theme.typography.generic.xxxLarge,
        flex: 1,
        height: '100%',
        overflow: 'auto',
        background: theme.palette.background.none,

        [theme.breakpoints.down('sm')]: {
            // display: 'none',
            padding: `${theme.typography.generic.xxxLarge}  ${theme.typography.generic.xLarge}`,
        },
    };
});

export const MainHeading = styled(({ ...props }) => <Typography component={'h1'} variant="heading1" fontFamily={'fontFamilyCondensed'} color={'text.primary'} {...props} />)(({ theme }) => ({}));
export const HeadingText = styled(({ ...props }) => <Typography component={'h5'} variant="paraText1" {...props} color={'text.secondary'} />)(({ theme }) => ({}));
export const ParaText = styled(({ ...props }) => <Typography component="p" variant="paraText3" color="text.secondary" {...props} />)(({ theme }) => ({}));

// styles for modal form labels
// New Task Add Button Mui css...........................
export const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: '#2ECA45',
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#39393D',
        }),
    },
}));

export const FormControlLabelStyled = styled(FormControlLabel)(({ theme }) => ({
    justifyContent: 'space-between',
    marginLeft: 0,
    marginRight: 0,

    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: theme.typography.borderRadius.xxSmall,

    padding: `${theme.typography.generic.xLarge} ${theme.typography.generic.xLarge}`,

    '&:hover': {
        border: `1px solid ${theme.palette.primary.main}`,
    },

    '& .MuiTypography-root.MuiFormControlLabel-label': {
        color: theme.palette.text.primary,
        fontSize: theme.typography.customFontSize.large,
        fontWeight: theme.typography.fontWeightSemiBold,

        [theme.breakpoints.down('sm')]: {
            fontSize: theme.typography.customFontSize.medium,
        },
    },
}));
export const FormLabelStyled = styled(FormLabel)(({ theme }) => ({
    fontSize: theme.typography.customFontSize.small,
    fontWeight: theme.typography.fontWeightMedium,
    marginBottom: theme.typography.generic.xxxSmall,
}));

export const InfoBox = styled(Box)(({ theme }) => ({
    padding: `${theme.typography.generic.medium} ${theme.typography.generic.xSmall}`,
    background: theme.palette.brandSecondary[50],
    borderRadius: theme.typography.borderRadius.xxSmall,
    border: `1px solid ${theme.palette.info.main}`,
    color: theme.palette.info.main,
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '0.5rem',
    width: '100%',
}));
